
import { Component, Vue } from 'vue-property-decorator'
import { ClueService } from '@/services'
import { ElForm } from 'element-ui/types/form'

enum EditType {
    edit = 0,
    create = 1
}

enum TITLE_TYPE {
    edit = '修改数据源类别名称',
    create = '创建数据源类别'
}

@Component({})
export default class DataSourceSort extends Vue {
    private currDSId = -1
    private editType = EditType.create
    private isLoading = true
    private dataSList: any[] = []
    private dialogTitle = ''
    private dialogVisible = false
    private dataSource = {
        title: ''
    }
    private dataSourceRules = {
        title: { validator: this.titleValidator, trigger: 'change' }
    }

    private mounted() {
        this.initData()
    }

    get dataSSRef() {
        return this.$refs.dataSSRef as ElForm
    }

    private async initData() {
        this.isLoading = true
        const result = await ClueService.getDataSourceSortList()
        this.isLoading = false
        if (result.status === 200) {
            this.dataSList = result.data
        }
    }

    private async deleteDataSource(id: number) {
        const params = { id }
        this.isLoading = true
        const result = await ClueService.deleteDataSourceSort(params)
        this.isLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '删除成功'
            })
            return true
        }
        return false
    }

    private async updateDSS() {
        const params = {
            id: this.currDSId,
            name: this.dataSource.title
        }
        this.isLoading = true
        const result = await ClueService.updateDataSourceSort(params)
        this.isLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '修改成功'
            })
            return true
        }
        return false
    }
    
    private async createDSS() {
        const params = { name: this.dataSource.title }
        this.isLoading = true
        const result = await ClueService.createDataSourceSort(params)
        this.isLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '创建数据源分类成功'
            })
            return true
        }
        return false
    }

    private onDialogOpen() {
        this.dialogTitle = this.editType === EditType.create ? 
            TITLE_TYPE.create : TITLE_TYPE.edit
    }

    private onDialogClosed() {
        this.dataSSRef.clearValidate()
        this.dataSource.title = ''
    }

    private onCreateType() {
        this.editType = EditType.create
        this.dialogVisible = true
    }

    private onEditType(type: { id: number, name: string }) {
        this.editType = EditType.edit
        this.currDSId = type.id
        this.dataSource.title = type.name
        this.dialogVisible = true
    }

    private onDelete(id: number) {
        this.$confirm('是否确定删除此数据源分类?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let result = await this.deleteDataSource(id)
            result && this.initData()
        }).catch()
    }

    private onComfirm() {
        this.dataSSRef.validate(async (isValid: boolean) => {
            if (isValid) {
                let result = false
                switch (this.editType) {
                    case EditType.edit:
                        result = await this.updateDSS()
                        break 
                    case EditType.create:
                        result = await this.createDSS()
                        break
                    default:
                        break
                }
                result && this.initData()
                this.dialogVisible = false
            }
        })
    }

    private titleValidator(rule: any, value: string, callback: Function) {
        if (!this.dialogVisible) return
        const length = value.length
        let message = ''
        if (!length) {
            message = '请输入正确的数据源分类名称'
        } else if (length < 2) {
            message = '至少2个字符以上'
        } else if (length > 10) {
            message = '名称在10个字符以内'
        }
        message && callback(new Error(message))
        callback()
    }
}
